"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messagesWatcher = messagesWatcher;

var _effects = require("redux-saga/effects");

var _apiRequest = require("../api/apiRequest");

var actions = _interopRequireWildcard(require("./actions"));

var types = _interopRequireWildcard(require("./types"));

var messagesActions = _interopRequireWildcard(require("../../messages/actions"));

var _Utils = _interopRequireDefault(require("../../../utils/Utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(messagesWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(messagesWatcher);

function messagesWorker(action) {
  var locale, localeCode, dto;
  return regeneratorRuntime.wrap(function messagesWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          locale = action.payload.locale;
          _context.next = 4;
          return (0, _effects.put)(actions.start());

        case 4:
          localeCode = _Utils["default"].getLocaleCode(locale);
          _context.next = 7;
          return (0, _effects.call)(_apiRequest.apiRequest, "internationalization/messages", "GET", {
            query: {
              lang: localeCode
            },
            auth: false
          });

        case 7:
          dto = _context.sent;
          _context.next = 10;
          return (0, _effects.put)(messagesActions.set(dto.messages));

        case 10:
          _context.next = 12;
          return (0, _effects.put)(actions.success());

        case 12:
          _context.next = 19;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          _context.next = 19;
          return (0, _effects.put)(actions.failure());

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 14]]);
}

function messagesWatcher() {
  return regeneratorRuntime.wrap(function messagesWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, messagesWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}